import React, { useState, FC } from "react";
import { Form, InputNumber, Button, Select, Space, AutoComplete } from "antd";
import { FormattedMessage } from "react-intl";
import { useGlobalState } from "../../context/Provider";
import { GetSkuId } from "../../api/sku";

interface AdditionBatchFormIprops {
  handleAdd: any;
}

const AdditionBatchSkuForm: FC<AdditionBatchFormIprops> = (props) => {
  const { handleAdd }: any = props;
  const [autoCompleteData, setAutoCompleteData] = useState([]);
  const { langState }: any = useGlobalState();
  const [id, setId] = useState<number>();
  const language: string = langState.locale;
  const [form] = Form.useForm();

  const handleSkuData = (value: string) => {
    GetSkuId(value).then((res: any) => {
      if (res.status === 200) {
        const completeData = res.data.map((item: any) => ({
          value: item.sku,
          id: item.id,
        }));
        setAutoCompleteData(completeData);
      }
    });
  };

  const handleAddSku = (values: any) => {
    form.resetFields();
    handleAdd({ ...values, id });
  };

  return (
    <>
      <Space align="start">
        <Form
          form={form}
          layout="inline"
          onFinish={handleAddSku}
          style={{ alignItems: "start" }}
          initialValues={{ modifier: "public" }}
        >
          <Form.Item
            label="skuId"
            name="skuId"
            key="skuId"
            rules={[
              {
                required: true,
                message:
                  language === "en-US"
                    ? "Please select your typs!"
                    : "لطفا نوع رو انتخاب کنید ",
              },
            ]}
          >
            <AutoComplete
              options={autoCompleteData}
              style={{ width: 140 }}
              onSearch={handleSkuData}
              placeholder="SKU ID"
              onSelect={(data: string, option: any) => setId(option.id)}
            />
          </Form.Item>

          <Form.Item
            label={language === "en-US" ? "count" : "تعداد"}
            name="quantity"
            rules={[
              {
                required: true,
                message:
                  language === "en-US"
                    ? "Please select your typs!"
                    : "لطفا نوع رو انتخاب کنید ",
              },
            ]}
          >
            <InputNumber min={0} max={100000} />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            <FormattedMessage id="additionBatch.addrow" />
          </Button>
        </Form>
      </Space>
    </>
  );
};

export default AdditionBatchSkuForm;
